// project imports
import MinimalLayout from 'layout/MinimalLayout';
import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';

const AuthSignTicket = Loadable(lazy(() => import('views/authentication/auth-pages/SignTicket')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const BaseRoute = {
    path: '/',
    element: <MinimalLayout />,
    children: [{ path: '/sign-ticket/:hash/:id', element: <AuthSignTicket /> }]
};

export default BaseRoute;
